export default "__VITE_ASSET__763830ef__"